import { render, staticRenderFns } from "./addContactPatient.vue?vue&type=template&id=680a2f82&scoped=true"
import script from "./addContactPatient.vue?vue&type=script&lang=js"
export * from "./addContactPatient.vue?vue&type=script&lang=js"
import style0 from "./addContactPatient.vue?vue&type=style&index=0&id=680a2f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a2f82",
  null
  
)

export default component.exports